<template>
  <div>
    <section class="pb-2">
      <b-col class="d-flex justify-content-between px-0 pt-25">
        <b-button
          v-b-modal.modal-create-edit-section-group
          variant="primary"
          :disabled="isLoading"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Admin.Info.AddSectionGroup') }}
        </b-button>
        <SearchInputField
          :disabled="isLoading"
          :placeholder="$tk('Admin.Accounts.Search')"
          @onInputSearch="onSearchChange"
        />
      </b-col>
      <b-card
        class="my-50"
        no-body
      >
        <Table
          :data="sectionGroups"
          :columns="sectionGroupsColumns"
          :is-loading="isLoading"
          type-of-table="info"
          :enable-pagination="false"
        />

        <b-modal
          id="modal-create-edit-section-group"
          :ok-title="sectionGroupModel.id ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.Add')"
          :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
          hide-header-close
          centered
          cancel-variant="outline-secondary"
          size="md"
          :title="sectionGroupModel.id ? $tk('ClientPortal.Admin.Info.EditSectionGroup') : $tk('ClientPortal.Admin.Info.NewSectionGroup')"
          no-enforce-focus
          :ok-disabled="saving || isFormComplete()"
          @show="getSectionGroupModel"
          @change="getSectionGroups"
          @ok="save"
        >
          <b-form-group
            :label="$tk('ClientPortal.Form.Name')"
            label-size="xs"
            :invalid-feedback="errors['Name']"
          >
            <b-form-input
              v-model="sectionGroupModel.name"
              size="sm"
              type="text"
              :placeholder="$tk('ClientPortal.Form.NamePlaceholder')"
              :state="errors['Name'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Admin.Info.Description')"
            label-size="xs"
            :invalid-feedback="errors['Description']"
          >
            <b-form-textarea
              v-model="sectionGroupModel.description"
              type="text"
              no-resize
              :placeholder="$tk('ClientPortal.Form.DescriptionPlaceholder')"
              :state="errors['Description'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Admin.Info.Active')"
            label-size="xs"
            class="mb-0"
          >
            <b-form-checkbox
              v-model="sectionGroupModel.active"
              class="d-block"
              checked="false"
              name="check-button"
              switch
            />
          </b-form-group>
        </b-modal>
      </b-card>
    </section>
  </div>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Table from '@/components/Table.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import notification from '@/mixins/toastification'
import InfoService from '@/api/admin/info.service'
import translation from '@/mixins/translate'
import store from '@/store'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    SearchInputField,
    GjIcon,
    Table,
  },
  mixins: [notification],
  setup() {
    const sectionGroupsColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Id'),
        field: 'id',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Name'),
        field: 'name',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Description'),
        field: 'description',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Info.Active'),
        field: 'active',
      },
    ]
    const isLoading = ref(false)
    const sectionGroups = computed(() => store.getters.getSectionGroups)
    const errors = ref({})
    const sectionGroupModel = ref({})
    const saving = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getSectionGroups')
      sectionGroups.value.searchTerm = ''
      isLoading.value = false
    })

    const getSectionGroups = async () => {
      await store.dispatch('getSectionGroups')
    }

    const getSectionGroupModel = () => {
      sectionGroupModel.value = store.getters.getSectionGroupModel
      errors.value = {}
      store.commit('SET_SECTION_GROUP_MODEL', {})
    }

    const isFormComplete = () => {
      const { name } = sectionGroupModel.value
      return !(name)
    }

    const save = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      let response = {}
      try {
        if (!sectionGroupModel.value.id) {
          response = await InfoService.createSectionGroup(sectionGroupModel.value)
        } else {
          response = await InfoService.updateSectionGroup(sectionGroupModel.value)
        }
        if (response.saved) {
          bvModalEvt.vueTarget.hide('modal-create-edit-section-group')
          response.message
            ? notification.methods.success(response.message)
            : notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        saving.value = false
        await store.dispatch('getSectionGroups')
      }
    }

    const onSearchChange = async value => {
      sectionGroups.value.searchTerm = value
    }

    return {
      isLoading,
      sectionGroups,
      errors,
      sectionGroupModel,
      saving,
      getSectionGroupModel,
      getSectionGroups,
      save,
      isFormComplete,
      onSearchChange,
      sectionGroupsColumns,
    }
  },
}
</script>
